/*
  MAISON FERMOIR, 29/09/2026 — une hauteur d'écran qui ne bouge pas au défilement.

  Sur Brave mobile, `vh` suit la barre d'outils qui se replie quand on descend :
  la bannière d'accueil (hauteur mobile en vh) grandissait puis rétrécissait au
  retour. Safari fige `vh`, d'où un défaut invisible sur Safari.

  On mesure `100vh` UNE fois au chargement — la valeur exacte que Safari utilise
  déjà, donc rien ne change chez lui — et on la pose en `--mf-vh` (1 % de l'écran).
  On ne remesure que si la LARGEUR change (rotation), jamais au défilement.
  Lu par `blocks/_image-banner.liquid`, avec repli sur 1vh si ce script manque.
*/
(function () {
  var largeur = 0;
  function mesurer() {
    if (window.innerWidth === largeur) return;
    largeur = window.innerWidth;
    var sonde = document.createElement('div');
    sonde.style.cssText = 'position:fixed;top:0;left:0;width:0;height:100vh;visibility:hidden;pointer-events:none';
    document.documentElement.appendChild(sonde);
    var h = sonde.getBoundingClientRect().height;
    sonde.remove();
    if (h > 0) document.documentElement.style.setProperty('--mf-vh', h / 100 + 'px');
  }
  mesurer();
  window.addEventListener('resize', mesurer);
})();
